import React from "react";
import { Grid } from "@material-ui/core";
import "./shop-content.component.sass";
import BuildingCreateSectionComponent from "../building-create-section/building-create-section.component";

export default function ShopContent() {
  const createTag = "/create-tag.png";
  return (
    <div className="shop-content">
      <Grid container>
        <Grid item sm={12} md={6} style={{ textAlign: "center", flexGrow: 1 }}>
          <img src={createTag} alt="shop-tags" width="60%" className="tag-img"/>
        </Grid>
        <Grid item sm={12} md={6} style={{ flexGrow: 1 }}>
          <BuildingCreateSectionComponent />
        </Grid>
      </Grid>
    </div>
  );
}
